module.exports = __webpack_public_path__ + "static/elected-officials-managers-3-722bc9ea6c6e1b66bb3b6811e15f6cb4.jpg";